import { motion, MotionProps } from "framer-motion";
import { forwardRef } from "react";

type AnimatedBarProps = JSX.IntrinsicElements["div"] &
  MotionProps & {
    loading?: boolean;
  };

const AnimatedBar = forwardRef<HTMLDivElement, AnimatedBarProps>(
  ({ loading = false, ...props }, ref) => {
    return (
      <motion.div
        transition={{ duration: 0.5 }}
        whileHover={
          !loading
            ? {
                scale: 1.03,
                background: "var(--new-neutral-cards-300)",
              }
            : undefined
        }
        ref={ref}
        {...props}
      />
    );
  },
);

export default AnimatedBar;
